"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.netswap = void 0;
exports.netswap = {
    router: '0x1E876cCe41B7b844FDe09E38Fa1cf00f213bFf56',
    masterchef: '0x9d1dbB49b2744A1555EDbF1708D64dC71B0CB052',
};
